/**
 * Has class helper method
 * @param {DOMelement} el - the element to add a class to
 * @param {String} className - the class to add
 * @return {Boolean} if the element has the class
 */
const hasClass = (element, className) => {
  if (element === null) {
    return false;
  }

  if (element.classList) {
    return element.classList.contains(className);
  }
  return new RegExp(`(^| )${className}( |$)`, 'gi').test(element.className);
};
export default hasClass;
